import { createContext } from 'react';

import { Player } from '../interfaces/player/player.interface';

export const PlayerContext = createContext<Player>({} as Player);